import React, { Component } from 'react';
import BufImageGrey32 from './BufImageGrey32.js';
import Popup from './Popup.js';

class DataViewer extends Component {

    constructor(props) 
    {
        super(props)

        this.state = {
            application: props.application,
            data: props.data,
            doi: "",
            viewerIsShown: props.viewerIsShown,
            showData: props.showData,
            
        }

        if (this.state.application)
        {
            this.updateDataView = this.updateDataView.bind(this)
            this.state.application.setUpdateDataView(this.updateDataView)
        }

        this.clearDataView = this.clearDataView.bind(this)
    }
    
    clearDataView(){
        this.updateDataView(null)
    }

    updateDataView(data_to_view)
    {
        this.setState({
            data: data_to_view,
        })
    }

    


    render()
    {
       if (null == this.state.data)

            return (<div className="DataViewer p-2 bg-secondary rounded mb-0 text-white">
           {this.props.viewerIsShown ? <div><div className="col-md-12 font-weight-bold m-2">DATA VIEW</div>
           <div className="alert alert-success alert-dismissible fade show text-truncate text-left m-2">Fetch manifest and/or data</div> </div>: null}
            </div>);

            

        let clearBtn = ""
        if (this.state.application)
            clearBtn = <div><button className="btn btn-sm btn-warning m-3" onClick={this.clearDataView}>Clear</button></div>

        let data_to_view = "Not supported to view MIME (" + this.state.data.MIME + ")"

        if (-1 !== this.state.data.MIME.indexOf("text"))
        {
            if (0 !== this.state.data.data.length) {
                let utf8decoder = new TextDecoder();
                data_to_view = utf8decoder.decode(new Uint8Array(this.state.data.data))
            }
            else
                data_to_view = "{empty}"
        }

        if (-1 !== this.state.data.MIME.indexOf("json"))
            data_to_view = JSON.stringify(this.state.data.data, undefined, 2)

        if (-1 !== this.state.data.MIME.indexOf("manifest"))
            data_to_view = JSON.stringify(this.state.data.data.json, undefined, 2)
        
        if (-1 !== this.state.data.MIME.indexOf("octet-stream"))
            data_to_view = this.stringFromOctetStream(this.state.data.data)

        if (-1 !== this.state.data.MIME.indexOf("BufImage/Grey32"))
            data_to_view = <BufImageGrey32 data={this.state.data.data}/>

        
            
        return (

       
           (this.props.viewerIsShown !== false) ?
            <div className="DataViewer bg-secondary rounded mb-0 text-white p-2">
                     <div className="col-md-12 font-weight-bold m-2">DATA VIEW</div>
                    <div className="alert alert-success alert-dismissible fade show text-truncate m-2"><pre className="text-left row m-2 container-fluid">{data_to_view}</pre></div>
                    <div>{this.state.doi}</div>
                    <div className="col-md-12">
                    {clearBtn}</div>
           </div> : 
           (this.props.showData !== false) ? <Popup data={data_to_view} closePopup={this.props.dataTogglePopup}/> : null 
            );
    }

    stringFromOctetStream(data)
    {
        const maxCount = 50;
        var str = "";
        var count = data.length;

        if (count > maxCount)
        {
            count = maxCount;
            str = "First " + maxCount + " bytes: ";
        }

        for (var index = 0; index < count;)
        {
            var ch = data[index++];
            
            var res = ch.toString(16).toUpperCase();
            
            if (res.length === 1) res = '0' + res;
            
            str += res;
        }

        return str
    }
}

export default DataViewer;